import { useMsal } from "@azure/msal-react";
import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import appRoles from "./Roles";

const AdminRouteGuard = (props) => {
	const { allowCst, children } = props;

	const { instance } = useMsal();
	const navigate = useNavigate();
	const [isAllowedAccess, setIsAllowedAccess] = useState(false);

	const onLoad = useCallback(async () => {
		const currentAccount = instance.getAllAccounts()[0];

		if (currentAccount?.idTokenClaims?.roles) {
			const adminRole = currentAccount.idTokenClaims.roles.indexOf(appRoles.admin) > -1;
			const cstRole = currentAccount.idTokenClaims.roles.indexOf(appRoles.cst) > -1;

			const allowAccess = adminRole || (allowCst && cstRole);

			if (adminRole || (allowCst && cstRole)) {
				setIsAllowedAccess(true);
			}

			if (!allowAccess) {
				navigate("/");
			}
		}
	}, [instance, allowCst, navigate]);

	useEffect(() => {
		onLoad();
	}, [onLoad]);

	return <span>{isAllowedAccess ? <div>{children}</div> : ""}</span>;
};
AdminRouteGuard.propTypes = {
	allowCst: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

AdminRouteGuard.defaultProps = {
	allowCst: false,
};

export default AdminRouteGuard;
